module.exports = __webpack_public_path__ + "img/Image.2044296e.png";